import React, { useState } from 'react'
import * as S from './styles'
import { getFormattedFields } from './constants'
import { ReactComponent as PawIcon } from '../../../../assets/icons/paw-vet-secondary.svg'
import { ReactComponent as EditIcon } from '../../../../assets/icons/green-pen.svg'
import NewPetModal from '../Modals/NewPetModal'

const PetsDataCard = ({ hasBorder, hasTopBorder, isEditable, isAppointment, data, updated }) => {
  const PET_DATA = getFormattedFields(data, isAppointment)

  const [isPetModalVisible, setIsPetModalVisible] = useState(false)

  const handleEditPet = () => {
    setIsPetModalVisible(true)
    updated(false)
  }

  return (
    <S.Container hasBorder={hasBorder} hasTopBorder={hasTopBorder} isEditable={isEditable}>
      <S.SideIcon>
        <PawIcon />
      </S.SideIcon>
      <S.Section separator>
        <S.Title>{PET_DATA.name}</S.Title>
        <S.Subtitle>{PET_DATA.subtitle}</S.Subtitle>
      </S.Section>
      <S.Section>
        <S.Field>
          <strong>Sexo: </strong>
          {PET_DATA.sex ? PET_DATA.sex : 'Não informado'}
        </S.Field>
        <S.Field>
          <strong>Espécie: </strong>
          {PET_DATA.type}
        </S.Field>
      </S.Section>
      <S.Section>
        <S.Field>
          <strong>Raça: </strong>
          {PET_DATA.breed}
        </S.Field>
        <S.Field>
          <strong>Peso: </strong>
          {PET_DATA.weight ? PET_DATA.weight : 'Não informado'}
        </S.Field>
      </S.Section>
      <S.Section>
        <S.Field>
          <strong>Idade: </strong>
          {PET_DATA.age ? PET_DATA.age : 'Não informado'}
        </S.Field>
        <S.Field>
          <strong>Nascimento: </strong>
          {PET_DATA.birthdate ? PET_DATA.birthdate : 'Não informado'}
        </S.Field>
      </S.Section>
      <S.Section>
        <S.Field>
          <strong>Castrado: </strong>
          {PET_DATA.castrated}
        </S.Field>
        <S.Field>
          <strong>Temperamento: </strong>
          {PET_DATA.temperament}
        </S.Field>
      </S.Section>
      {isEditable &&
        <S.EditableArea>
          <S.Button onClick={handleEditPet}>
            <EditIcon />
          </S.Button>
        </S.EditableArea>}
      <NewPetModal petData={data} visibility={isPetModalVisible} setVisibility={setIsPetModalVisible} updated={() => updated(true)} />
    </S.Container>
  )
}
export default PetsDataCard
